/* global alert */
import React from 'react';
import { string } from 'prop-types';

const ShopperApprovedBlock = ({ sealId, reviewsUrl }) => {
    const handleContextMenu = (e) => {
        e.preventDefault();
        const d = new Date();
        alert('Copying Prohibited by Law - This image and all included logos are copyrighted by Shopper Approved (c) '+d.getFullYear()+'.');
        return false;
    };
    if (!sealId || !reviewsUrl) {
        return null;
    }
    return (<div
        className={'mb-3'}>
        <p>Shop with confidence</p>
        <a
            href={reviewsUrl}
            className={'shopperlink new-sa-seals placement-default'}>
            <img
                loading={'lazy'}
                src={`//www.shopperapproved.com/seal/${sealId}/default-sa-seal.gif`}
                width={166}
                height={56}
                style={{ borderRadius: '4px' }}
                alt={'Customer Reviews'}
                onContextMenu={handleContextMenu} />
        </a>
    </div>);
};

ShopperApprovedBlock.propTypes = {
    sealId: string,
    reviewsUrl: string,
};

export default ShopperApprovedBlock;